export default __webpack_public_path__ + "static/media/like.01ea578e.svg";